import ECommPage from "./ECommPage";
export default ECommPage;
